'use client';

import * as React from 'react';
import { useIsMyProfile } from '../../hooks/use-is-my-profile';
import { ProfileProvider } from '../profile-provider';
import { PrivateProfilePage } from './private-profile-page';
import * as Styled from './profile-page.styled';
import { PublicProfilePage } from './public-profile-page';
export const ProfilePageLayout = React.memo(function ProfilePageLayout({
  children
}: React.PropsWithChildren) {
  const isMyProfile = useIsMyProfile();
  return <ProfileProvider>
      <Styled.Container>
        {isMyProfile ? <PrivateProfilePage>{children}</PrivateProfilePage> : <PublicProfilePage>{children}</PublicProfilePage>}
      </Styled.Container>
    </ProfileProvider>;
});